import React from 'react';

function PointDown({ color = 'text-shuttle-grey', size = 'w-3 h-3', className = '' }) {
	return (
		<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
			<g
				id="icon/monochrome/functions/navigation/point-down"
				stroke="none"
				className={`${size} fill-current ${color} ${className}`}
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
			>
				<g id="export">
					<rect id="box" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="16" height="16" />
					<path
						d="M3.25574396,3.34506952 L8,8.08932556 L12.744256,3.34506952 C13.0280866,3.06123896 13.3974661,2.90063916 13.8012783,2.90063916 C14.2050905,2.90063916 14.57447,3.06123896 14.8583006,3.34506952 L15.5555696,4.04233855 C15.8394002,4.32616911 16,4.69554865 16,5.09936084 C16,5.50317303 15.8394002,5.87255256 15.5555696,6.15638312 L9.05702228,12.6549305 C8.77319172,12.938761 8.40381219,13.0993608 8,13.0993608 C7.59618781,13.0993608 7.22680828,12.938761 6.94297772,12.6549305 L0.444430359,6.15638312 C0.160599797,5.87255256 0,5.50317303 0,5.09936084 C0,4.69554865 0.160599797,4.32616911 0.444430359,4.04233855 L1.14169939,3.34506952 C1.42552995,3.06123896 1.79490948,2.90063916 2.19872167,2.90063916 C2.60253386,2.90063916 2.9719134,3.06123896 3.25574396,3.34506952 Z"
						id="point-down"
					/>
				</g>
			</g>
		</svg>
	);
}

export default PointDown;
